var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlobSceneHaikei1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 675",
    width: 900,
    height: 675,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 675,
    fill: "#ddcece"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "25%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#ff3600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#ff3600",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "25%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#ff3600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#ff6f5b",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "25%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#faa09a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#ff6f5b",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "25%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#faa09a",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#ddcece",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "75%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#ff3600",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#ff3600",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "75%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#ff6f5b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#ff3600",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "75%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#ff6f5b",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#faa09a",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "75%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#ddcece",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#faa09a",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 421.9C-36.6 417.4 -73.1 412.9 -106.9 398.9C-140.6 385 -171.6 361.5 -193 334.3C-214.4 307.1 -226.3 276.1 -258.1 258.1C-289.9 240.1 -341.5 235.2 -365.4 210.9C-389.2 186.6 -385.4 143 -390.2 104.6C-395 66.2 -408.5 33.1 -421.9 0L0 0Z",
    fill: "#eeb7b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 316.4C-27.4 313 -54.9 309.7 -80.2 299.2C-105.5 288.7 -128.7 271.1 -144.7 250.7C-160.8 230.3 -169.8 207 -193.6 193.6C-217.4 180.1 -256.1 176.4 -274 158.2C-291.9 140 -289.1 107.2 -292.7 78.4C-296.3 49.6 -306.3 24.8 -316.4 0L0 0Z",
    fill: "#ff887c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 210.9C-18.3 208.7 -36.6 206.4 -53.4 199.5C-70.3 192.5 -85.8 180.8 -96.5 167.1C-107.2 153.5 -113.2 138 -129 129C-144.9 120.1 -170.7 117.6 -182.7 105.5C-194.6 93.3 -192.7 71.5 -195.1 52.3C-197.5 33.1 -204.2 16.5 -210.9 0L0 0Z",
    fill: "#ff5437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 105.5C-9.1 104.3 -18.3 103.2 -26.7 99.7C-35.2 96.2 -42.9 90.4 -48.2 83.6C-53.6 76.8 -56.6 69 -64.5 64.5C-72.5 60 -85.4 58.8 -91.3 52.7C-97.3 46.7 -96.4 35.7 -97.6 26.1C-98.8 16.5 -102.1 8.3 -105.5 0L0 0Z",
    fill: "#ff3600"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -421.9C22.9 -373.9 45.9 -325.9 87.7 -327.4C129.6 -329 190.4 -380.1 210.9 -365.4C231.5 -350.6 211.9 -270 239 -239C266.1 -208 339.9 -226.7 361.1 -208.5C382.4 -190.3 351.2 -135.4 352.6 -94.5C353.9 -53.6 387.9 -26.8 421.9 0L0 0Z",
    fill: "#eeb7b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -316.4C17.2 -280.4 34.4 -244.4 65.8 -245.6C97.2 -246.8 142.8 -285.1 158.2 -274C173.6 -262.9 158.9 -202.5 179.3 -179.3C199.6 -156 254.9 -170 270.8 -156.4C286.8 -142.8 263.4 -101.5 264.4 -70.9C265.5 -40.2 290.9 -20.1 316.4 0L0 0Z",
    fill: "#ff887c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -210.9C11.5 -186.9 22.9 -162.9 43.9 -163.7C64.8 -164.5 95.2 -190.1 105.5 -182.7C115.8 -175.3 106 -135 119.5 -119.5C133 -104 169.9 -113.3 180.6 -104.3C191.2 -95.2 175.6 -67.7 176.3 -47.2C177 -26.8 194 -13.4 210.9 0L0 0Z",
    fill: "#ff5437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -105.5C5.7 -93.5 11.5 -81.5 21.9 -81.9C32.4 -82.3 47.6 -95 52.7 -91.3C57.9 -87.6 53 -67.5 59.8 -59.8C66.5 -52 85 -56.7 90.3 -52.1C95.6 -47.6 87.8 -33.8 88.1 -23.6C88.5 -13.4 97 -6.7 105.5 0L0 0Z",
    fill: "#ff3600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobSceneHaikei1);
export default __webpack_public_path__ + "static/media/blob-scene-haikei-1.c68458bf93d07a786ff0757333c398b3.svg";
export { ForwardRef as ReactComponent };